export const productsFr = {
    title: 'Produits',
    list: 'Liste des produits',
    detail: 'Détail du produit',
    create: 'Créer un produit',
    delete: 'Supprimer le produit',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce produit ?',
    columns: {
        id: 'ID',
        encoding: 'Encodage',
        productId: 'ID Produit',
        name: 'Nom',
        rfidChipTemplate: 'Template puce RFID',
        endRollLabelTemplate: 'Template fin de rouleau',
        actions: 'Actions'
    },
    model: {
        encoding: 'Encodage',
        productId: 'ID Produit',
        name: 'Nom du produit',
        rfidChipTemplate: 'Template puce RFID',
        endRollLabelTemplate: 'Template fin de rouleau',
        noTemplate: 'Aucun template'
    },
    errors: {
        fetchFailed: 'Impossible de charger les produits',
        createFailed: 'Impossible de créer le produit',
        updateFailed: 'Impossible de mettre à jour le produit',
        deleteFailed: 'Impossible de supprimer le produit'
    },
    success: {
        created: 'Produit créé avec succès',
        updated: 'Produit mis à jour avec succès',
        deleted: 'Produit supprimé avec succès'
    }
}
